import React from 'react'
import styles from './DonutSpinner.css'

const DonutSpinner = ({ colors }) => (
  <div className={styles.donutSpinnerWrapper}>
    <div
      className={styles.donutSpinner}
      style={{
        borderColor: colors.background,
        borderLeftColor: 'white'
      }}
    />
  </div>
)

export default DonutSpinner


// WEBPACK FOOTER //
// ./src/components/DonutSpinner/DonutSpinner.js